import { render, staticRenderFns } from "./SettingsLive.vue?vue&type=template&id=2bf3fd01&"
import script from "./SettingsLive.vue?vue&type=script&lang=js&"
export * from "./SettingsLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports